// Clases comunes de toda la app. Son los componentes de index.css (estilo del portal
// de proyectos: botones píldora, campos y paneles con borde translúcido).

export const campo = "campo";

export const etiqueta = "etiqueta";

export const botonPrimario = "btn-primario";

export const botonSecundario = "btn-fantasma";

export const botonPequeno = "btn-fantasma btn-sm";

export const botonPeligro = "btn-peligro btn-sm";

export const tarjeta = "panel p-5";

export const tituloPagina = "titulo-pagina";

export const tituloPanel = "titulo-panel";

export const pestana = (activa) => `pestana ${activa ? "pestana-activa" : ""}`;

// Texto de apoyo (rótulos de cifras, saludos), igual al gris de las pantallas originales.
export const antetitulo = "text-gray-400 text-sm";

export const fechaLarga = (fecha, opciones = { weekday: "long", day: "numeric", month: "long" }) =>
  fecha ? new Date(`${fecha}T00:00:00`).toLocaleDateString("es-CO", opciones) : "Sin fecha";

export const hora = (valor) => (valor ? String(valor).slice(0, 5) : "");

export const nombreReunion = (servicio) =>
  servicio?.titulo || servicio?.tipos_servicio?.nombre || servicio?.nombre || "Reunión";

export const hoyISO = () => new Date().toLocaleDateString("en-CA"); // AAAA-MM-DD en la zona local
